import { put } from "redux-saga/effects";
import { serverRequest, setForm3Section } from "../../actions";

export function* changeStatus3(action) {
  const { formDataId, formId, currentStateId, connectionId, to, force } =
    action;

  var payload = {
    action: "portal/changeStatus3",
    formDataId,
    formId,
    currentStateId,
    connectionId,
    to,
    force,
  };

  yield put(serverRequest(payload));
  //yield put(setForm3Section({index:0}))
}

export default changeStatus3;
